/*
 * @Description:
 * @Date: 2024-03-20 13:44:43
 */
import { computed, reactive, ref } from 'vue';
import { storeToRefs } from 'pinia';
import appStore from '@/store';

export const useZsStore = (() => {
  type State = {
    enterpriseId?: string | number;
    enterpriseName?: string;
    configId?: string | number;
    dataOrigin: 'own' | 'other' | '';
    text?: string;
  };
  const state = reactive<State>({
    dataOrigin: ''
  });

  return () => {
    return {
      configId: computed(() => state.configId),
      enterpriseId: computed(() => state.enterpriseId),
      enterpriseName: computed(() => state.enterpriseName),
      isIndustriaRole: computed(() => {
        const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
        return defaultUserFnCode.value === 1;
      }),
      isCsoRole: computed(() => {
        const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
        return defaultUserFnCode.value === 2;
      }),
      isOssRole: computed(() => false),
      isOwnPublish: computed(() => state.dataOrigin === 'own'),
      isOtherPublish: computed(() => state.dataOrigin === 'other'),
      dataOrigin: computed(() => state.dataOrigin),
      initState: () => {
        state.dataOrigin = 'own';
      },
      setValue<T extends keyof State>(key: T, value: State[T]) {
        state[key] = value;
      }
    };
  };
})();

export const useKeepaliveStore = (() => {
  /**
   * 缓存组件name
   */
  const keepaliveNames = ref<Set<string>>(new Set());
  const setKeepaliveNames = (names: Array<string>) => {
    keepaliveNames.value = new Set([...names]);
  };

  const delKeepaliveName = (name: string) => {
    keepaliveNames.value.delete(name);
  };
  const addKeepaliveName = (name: string) => {
    keepaliveNames.value.add(name);
  };

  return () => ({
    keepaliveNames,
    setKeepaliveNames,
    addKeepaliveName,
    delKeepaliveName
  });
})();
